import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorToolbarItemDirective } from './editor-toolbar-item.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    EditorToolbarItemDirective
  ],
  exports: [
    EditorToolbarItemDirective
  ]
})
export class EditorToolbarItemModule { }
